import { render, staticRenderFns } from "./BaseTradeInVoucherItem.vue?vue&type=template&id=89d43b32&scoped=true"
import script from "./BaseTradeInVoucherItem.vue?vue&type=script&lang=js"
export * from "./BaseTradeInVoucherItem.vue?vue&type=script&lang=js"
import style0 from "./BaseTradeInVoucherItem.vue?vue&type=style&index=0&id=89d43b32&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d43b32",
  null
  
)

export default component.exports